<template>

  <div class="main">
    <Animate ref="animate" />

    <cooperate-item :coops="cooperate"></cooperate-item>

    <pagination ref="paging" @pagingChange="pagingChange" :total="count"></pagination>
  </div>

</template>

<script>
  import CooperateItem from "../childComps/CooperateItem";
  import Pagination from "@/components/common/Pagination";
  import Animate from "@/components/common/Animate";

  import {ref, reactive, getCurrentInstance, onMounted } from 'vue'
  import { getCooperate, totalCooperate } from '@/network/cooperate'

  export default {
    name: "EnterpriseCooperation",
    components:{
      CooperateItem,
      Pagination,
      Animate,
    },
    setup(){


      let instance = reactive({});
      instance = getCurrentInstance();
      // 合作信息的总数
      let count = ref(0);
      let cooperate = reactive([])



      onMounted(() => {
        totalCooperate(1).then(res => {
          if (res.state === 200){
            count.value = res.data;                                 //用props传参不好用,不知道为啥
            instance.proxy.$refs.paging.pagination.total = res.data;  //这个方案好用
          }
        })
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })




      // methods
      // 点进页面即获取数据展示
      getCooperate(1, 0, 20).then(res => {
        if (res.state === 200)
          res.data.forEach(item => cooperate.push(item))
      })
      // 分页变化
      function pagingChange(pageSize, currentPage) {
        let length = 0;
        cooperate.length = 0;
        if ((currentPage - 1) * pageSize + pageSize > count.value)
          length = count.value - (currentPage - 1) * pageSize;
        else length = pageSize;
        getCooperate(1, (currentPage - 1) * pageSize, length).then(res => {
          if (res.state === 200){
            res.data.forEach(item => cooperate.push(item));
          }
        })
      }



      return{ cooperate, count,
        pagingChange,
      }
    }
  }
</script>

<style scoped lang="less">

  .main{
    padding-bottom: 50px;
  }

  .el-pagination{
    display: flex;
    justify-content: center;
    padding: 40px 20px 50px 0;
  }

</style>